const searchByKeyword = (data: string, keyword: string) => {
  const normalizedData = data.replace(/\s{2,}/g, " ")
  const normalizedKeyword = keyword.replace(/\s{2,}/g, " ")

  const regex = new RegExp(RegExp.escape(normalizedKeyword), "i")
  return regex.test(normalizedData)
}

export { searchByKeyword }
